import React, { createContext, useState, useContext } from 'react';

const translations = {
  // Common translations for both portal and main site
  common: {
    en: {
      appointments: 'Appointments',
      medicalRecords: 'Medical Records',
      visitHistory: 'Visit History',
      print: 'Print',
      exportData: 'Export Data',
      status: 'Status',
      doctor: 'Doctor',
      dateFrom: 'Date From',
      dateTo: 'Date To',
      all: 'All',
      pending: 'Pending',
      confirmed: 'Confirmed',
      cancelled: 'Cancelled',
      rescheduled: 'Rescheduled',
      noShow: 'No Show',
      completed: 'Completed',
      inProgress: 'In Progress',
      awaitingPayment: 'Awaiting Payment',
      clearFilters: 'Clear Filters',
      name: 'Name',
      email: 'Email',
      registered: 'Registered',
      totalAppointments: 'Total Appointments',
      date: 'Date',
      time: 'Time',
      service: 'Service',
      notes: 'Notes',
      action: 'Action',
      reschedule: 'Reschedule',
    },
    hi: {
      appointments: 'नियुक्तियां',
      medicalRecords: 'चिकित्सा रिकॉर्ड',
      visitHistory: 'विज़िट इतिहास',
      print: 'प्रिंट करें',
      exportData: 'डेटा निर्यात करें',
      status: 'स्थिति',
      doctor: 'डॉक्टर',
      dateFrom: 'तारीख से',
      dateTo: 'तारीख तक',
      all: 'सभी',
      pending: 'लंबित',
      confirmed: 'पुष्टि की गई',
      cancelled: 'रद्द की गई',
      rescheduled: 'पुनर्निर्धारित',
      noShow: 'नहीं आए',
      completed: 'पूरी हुई',
      inProgress: 'प्रगति में',
      awaitingPayment: 'भुगतान की प्रतीक्षा',
      clearFilters: 'फ़िल्टर साफ़ करें',
      name: 'नाम',
      email: 'ईमेल',
      registered: 'पंजीकृत',
      totalAppointments: 'कुल नियुक्तियां',
      date: 'तारीख',
      time: 'समय',
      service: 'सेवा',
      notes: 'नोट्स',
      action: 'कार्रवाई',
      reschedule: 'पुनर्निर्धारित करें',
    },
    gu: {
      appointments: 'એપોઇન્ટમેન્ટ્સ',
      medicalRecords: 'મેડિકલ રેકોર્ડ્સ',
      visitHistory: 'મુલાકાત ઇતિહાસ',
      print: 'પ્રિન્ટ કરો',
      exportData: 'ડેટા એક્સપોર્ટ કરો',
      status: 'સ્થિતિ',
      doctor: 'ડૉક્ટર',
      dateFrom: 'તારીખથી',
      dateTo: 'તારીખ સુધી',
      all: 'બધા',
      pending: 'બાકી',
      confirmed: 'પુષ્ટિ કરેલ',
      cancelled: 'રદ કરેલ',
      rescheduled: 'પુનઃનિર્ધારિત',
      noShow: 'હાજર ન રહ્યા',
      completed: 'પૂર્ણ થયેલ',
      inProgress: 'પ્રગતિમાં',
      awaitingPayment: 'ચુકવણીની રાહ જોઈ રહ્યા છે',
      clearFilters: 'ફિલ્ટર્સ સાફ કરો',
      name: 'નામ',
      email: 'ઈમેલ',
      registered: 'નોંધાયેલ',
      totalAppointments: 'કુલ એપોઇન્ટમેન્ટ્સ',
      date: 'તારીખ',
      time: 'સમય',
      service: 'સેવા',
      notes: 'નોંધ',
      action: 'ક્રિયા',
      reschedule: 'પુનઃનિર્ધારિત કરો',
    },
  },
  en: {
    services: 'Services',
    company: 'Company',
    resources: 'Resources',
    contactUs: 'Contact Us',
    stayUpdated: 'Stay Updated',
    subscribe: 'Subscribe',
    language: 'Language',
    privacyPolicy: 'Privacy Policy',
    termsOfService: 'Terms of Service',
    cookiePolicy: 'Cookie Policy',
    allRightsReserved: 'All rights reserved',
    enterEmail: 'Enter your email',
    generalMedicine: 'General Medicine',
    cardiology: 'Cardiology',
    pediatrics: 'Pediatrics',
    orthopedics: 'Orthopedics',
    diagnosticLab: 'Diagnostic Lab',
    aboutUs: 'About Us',
    medicalTeam: 'Medical Team',
    careers: 'Careers',
    patientStories: 'Patient Stories',
    healthBlog: 'Health Blog',
    patientPortal: 'Patient Portal',
    insurancePartners: 'Insurance Partners',
  },
  hi: {
    services: 'सेवाएं',
    company: 'कंपनी',
    resources: 'संसाधन',
    contactUs: 'संपर्क करें',
    stayUpdated: 'अपडेट रहें',
    subscribe: 'सदस्यता लें',
    language: 'भाषा',
    privacyPolicy: 'गोपनीयता नीति',
    termsOfService: 'सेवा की शर्तें',
    cookiePolicy: 'कुकी नीति',
    allRightsReserved: 'सर्वाधिकार सुरक्षित',
    enterEmail: 'अपना ईमेल दर्ज करें',
    generalMedicine: 'सामान्य चिकित्सा',
    cardiology: 'हृदय रोग विभाग',
    pediatrics: 'बाल रोग विभाग',
    orthopedics: 'हड्डी रोग विभाग',
    diagnosticLab: 'जांच प्रयोगशाला',
    aboutUs: 'हमारे बारे में',
    medicalTeam: 'चिकित्सा टीम',
    careers: 'करियर',
    patientStories: 'मरीजों की कहानियां',
    healthBlog: 'स्वास्थ्य ब्लॉग',
    patientPortal: 'मरीज पोर्टल',
    insurancePartners: 'बीमा भागीदार',
  },
  gu: {
    services: 'સેવાઓ',
    company: 'કંપની',
    resources: 'સંસાધનો',
    contactUs: 'સંપર્ક કરો',
    stayUpdated: 'અપડેટ રહો',
    subscribe: 'સબસ્ક્રાઇબ કરો',
    language: 'ભાષા',
    privacyPolicy: 'ગોપનીયતા નીતિ',
    termsOfService: 'સેવાની શરતો',
    cookiePolicy: 'કૂકી નીતિ',
    allRightsReserved: 'બધા અધિકારો સુરક્ષિત',
    enterEmail: 'તમારું ઈમેલ દાખલ કરો',
    generalMedicine: 'સામાન્ય દવા',
    cardiology: 'હૃદયરોગ વિભાગ',
    pediatrics: 'બાળરોગ વિભાગ',
    orthopedics: 'હાડકાં વિભાગ',
    diagnosticLab: 'નિદાન લેબ',
    aboutUs: 'અમારા વિશે',
    medicalTeam: 'મેડિકલ ટીમ',
    careers: 'કારકિર્દી',
    patientStories: 'દર્દીઓની વાર્તાઓ',
    healthBlog: 'આરોગ્ય બ્લોગ',
    patientPortal: 'દર્દી પોર્ટલ',
    insurancePartners: 'વીમા ભાગીદારો',
  },
};

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState('en');

  const value = {
    language,
    setLanguage,
    t: (key) => translations.common?.[language]?.[key] || translations[language]?.[key] || key,
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}
